import { ModuleRegistry } from "seneca-common/features/module/registry";

import { generateInitialUserAnswer, markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateContent } from "./logic/content";
import { canBeTested } from "./logic/tested";
import { initialiseState } from "./module-state";

export const MODULE_TYPE = "image-label";
export type TYPE = "image-label";
export { transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .getModuleAssets(getModuleAssets)
    .generateInitialUserAnswer(generateInitialUserAnswer)
    .generateInitialModuleState(initialiseState)
    .canBeTested(canBeTested)
    .back.staticInformation()
    .displayName("Image Label")
    .root.register();
